import React, { useState , useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import FormCheck from 'jd-library/FormCheck'
import Button from "jd-library/Button";
import toastMessageActions from "jd-library/toastMessageActions";
import Modal from "jd-library/Modal";
import Loader from '../../common/Loader/Loader';
import {getContractorData,setConnectedNumber} from "../../actions/contractor";
import { showToastMessage } from '../../actions/toastmessage';
import "./connected-number.scss";


const ConnectedNumber = (props) => {

    const [selectNumbers, setSelectNumbers] = useState([...props.data])
    const [showLoader, toggleLoader] = useState(false);
    const isAuditor = props.isAuditor || false;
    const dispatch = useDispatch();
    const docId = props.docId  || '';

    const numberCheck = (num,index) => {
        let newItem = [...selectNumbers]
        newItem[index] = {...newItem[index],isChecked: num.isChecked === 1 ? 0 : 1};
        setSelectNumbers([...newItem]);
    }
    
    const connectedNumberSave = () => {
        const checked = selectNumbers.find(item => item.isChecked == 1)
        if (!isAuditor){
            if (!checked){
                dispatch(toastMessageActions.showMessage({
                    message: "Please Select Atleast One Connected Phone Number",
                    showReduxToast: true,
                    animationTime :10000
                }))
            }else {
                const sendObj = {
                    numbers : JSON.stringify(selectNumbers),
                    docId : docId
                }
                if (sendObj){
                    toggleLoader(true);
                }
                dispatch(setConnectedNumber(sendObj,{
                        cb : data => {
                            dispatch(showToastMessage({
                            showToastMessage: true,
                            message: data.data.msg,
                            duration: 1000,
                            type: 'error'
                        }));
                        setTimeout(() => {
                                if (data.data.isError == 0) {
                                    toggleLoader(false);
                                    checked && props.onHidden();
                                    props.onChangePageReload();
                                }   
                            }, 800);
                        }
                })) 
            }
        }
        isAuditor && props.onHidden();
    }
    const getDetailsModal = (options = {}) => {
        return (<>
            <Modal.CloseIcon />
            <div className = {`connected-number-modal`}>
                <div className='modalHead'>
                    <div className={'header'}>
                    {isAuditor  ?  `Connected Numbers` : `Select Connected Numbers`}
                </div>
                <div className={'subHeader'}>
                    {isAuditor  ? `` : `Please select the phone number (s) on which owner was contacted`}
                </div>
                </div>
                <div 
                    className='modalBody' 
                    body-scroll-lock-ignore='true'
                >
                    {selectNumbers && selectNumbers.map((cur,index) => {
                            return (
                                <div className = 'company-name'>
                                   {!isAuditor ? <div className='chkBox'><FormCheck  rippleColor='rgba(33, 37, 41, .1)' label={`+91 ${cur.mobile}` || ''} checked={cur.isChecked} onClick={(e) => numberCheck(cur,index)} name={`${cur.mobile}`}/></div>
                                        : 
                                    <div className={`${selectNumbers.length == 1 ? "mobNum-single" : "mobNum"}`}>{cur.mobile || ''}</div>
                                    } 
                                </div>
                        )
                    })}
                </div>
                <div className='modalFooter'>
                    {<Button
                    size='lg'
                    block
                    className={'send-link-btn'}
                    onClick={() => {
                        setTimeout(() => {
                            connectedNumberSave()
                           
                        },500)
                    }}
                >
                    {!isAuditor  ?  `Save` : `Close`}  
                    <div className='connected-numbers-Loader'>
                    {showLoader &&
                        <Loader style={{width: '25px', height: '25px', marginLeft: '155px',marginTop: '8px'}}/>
                    }
	        </div>
                </Button>}
                </div>
                
                    
            </div>
        </>);
    };

    


  return (
    <>
            <Modal
                settings={{
                    modalId: 'detailModal',
                    variant: 'webstore',
                    class: `wide-modal`
                }}
                onHidden={() => {
                    props.onHidden();                  
                }}
            >       {getDetailsModal((!isAuditor) ? {item: props?.data.data?.ownerConnectedMobileList} : {})}
            </Modal>
    </>
  )
}


const mapStateToProps = state => {
    return {
        session: state.session,
    };
}

export default connect(mapStateToProps,{
    showToastMessage: toastMessageActions.showMessage,
    getContractorData,
}) (ConnectedNumber);


